
//Diverse Buttons in der Oberflaeche sollen zwecks Tracking ein Event ausloesen
$(function(){
    $('.vega_event_btn').on('click',function(){
        vegaTrackEvent($(this).data('vega_event_name'));
    })
})

function vegaTrackEvent(eventName){
    const eventData = {
        event: '' + eventName + '',
        detail: {}
    };
    const vegaEvent = new CustomEvent('vega-event',{detail: eventData});
    window.dispatchEvent(vegaEvent)
}